import { ViewParameter } from './ViewParameter';
import { BreadCrumbSelectMode } from './IRouteParameter';
import { BreadCrumbItem } from './BreadCrumbItem';
import { Misc } from '@singularsystems/neo-core';
import { NeoReactTypes } from '..';
var ViewParameterList = /** @class */ (function () {
    function ViewParameterList(routeParameterObject, view) {
        this.view = view;
        this.params = [];
        this.suppressNavigation = false;
        this.hasSuppressedNavigation = false;
        if (routeParameterObject) {
            for (var param in routeParameterObject) {
                var viewParam = new ViewParameter(this, param, routeParameterObject[param]);
                //@ts-ignore
                this[param] = viewParam;
                this.params.push(viewParam);
            }
        }
    }
    ViewParameterList.prototype.getBreadCrumbList = function (upTo) {
        var _a;
        var basePath = Misc.Globals.appService.get(NeoReactTypes.Routing.NavigationHelper).getCurrentViewPath();
        var breadCrumbs = [];
        var state = { hasQuery: false };
        var queryPath = this.getQueryString(state);
        var paramPath = basePath;
        var selectablePath = basePath;
        for (var _i = 0, _b = this.params; _i < _b.length; _i++) {
            var viewParam = _b[_i];
            if (!viewParam.routeParameter.isQuery) {
                if (!upTo) {
                    for (var _c = 0, _d = viewParam.prefixes; _c < _d.length; _c++) {
                        var prefix = _d[_c];
                        var breadcrumbItem = new BreadCrumbItem(prefix.label);
                        if (prefix.onClick) {
                            breadcrumbItem.onClick = prefix.onClick;
                        }
                        else if (prefix.link) {
                            breadcrumbItem.link = prefix.link;
                        }
                        else if (prefix.value) {
                            breadcrumbItem.link = paramPath + "/" + prefix.value;
                        }
                        breadCrumbs.push(breadcrumbItem);
                    }
                }
                paramPath += viewParam.getParamString(state);
                if (((_a = viewParam.routeParameter.selection) !== null && _a !== void 0 ? _a : BreadCrumbSelectMode.Default) === BreadCrumbSelectMode.Default) {
                    selectablePath = paramPath;
                }
                if (viewParam.description || (upTo && viewParam.latestValue !== null)) {
                    breadCrumbs.push(new BreadCrumbItem(viewParam.description, (!upTo && viewParam.routeParameter.selection === BreadCrumbSelectMode.None) ? "" : (selectablePath + queryPath)));
                }
            }
            if (upTo && upTo === viewParam) {
                break;
            }
        }
        if (breadCrumbs.length === 0 && state.hasQuery) {
            breadCrumbs.push(new BreadCrumbItem("", queryPath));
        }
        return breadCrumbs;
    };
    ViewParameterList.prototype.getQueryString = function (state) {
        var queryPath = "";
        for (var _i = 0, _a = this.params; _i < _a.length; _i++) {
            var viewParam = _a[_i];
            if (viewParam.routeParameter.isQuery) {
                queryPath += viewParam.getParamString(state);
            }
        }
        return queryPath;
    };
    ViewParameterList.prototype.setValues = function (values, options) {
        var _a;
        this.suppressNavigation = true;
        this.hasSuppressedNavigation = false;
        options !== null && options !== void 0 ? options : (options = {});
        if (typeof options === "boolean") {
            options = { force: true }; // parameter used to be named 'force'- backwards compatibility.
        }
        for (var paramName in values) {
            //@ts-ignore
            this[paramName].value = (_a = values[paramName]) !== null && _a !== void 0 ? _a : null;
        }
        this.suppressNavigation = false;
        if (this.hasSuppressedNavigation || options.force) {
            this.setUrl(this.params[this.params.length - 1], options.replace);
        }
    };
    ViewParameterList.prototype.setUrl = function (viewParameter, replace) {
        if (replace === void 0) { replace = false; }
        if (this.suppressNavigation) {
            this.hasSuppressedNavigation = true;
        }
        else {
            var navigationHelper = Misc.Globals.appService.get(NeoReactTypes.Routing.NavigationHelper);
            if (viewParameter) {
                var allItems = this.getBreadCrumbList(viewParameter);
                if (allItems.length > 0) {
                    navigationHelper.navigateInternal(allItems[allItems.length - 1].link, replace);
                    return;
                }
            }
            navigationHelper.navigateInternal(navigationHelper.getCurrentViewPath(), replace);
        }
    };
    /**
     * Updates the parameter values from the values in the url. Returns true if any of the values have changed.
     */
    ViewParameterList.prototype.update = function (match) {
        var hasChanged = false;
        //Get url params
        for (var param in match.params) {
            //@ts-ignore
            var viewParam = this[param];
            if (viewParam) {
                // @ts-ignore
                var value = match.params[param];
                if (value === undefined)
                    value = null;
                if (viewParam.update(value))
                    hasChanged = true;
            }
        }
        //Get query params
        var queryParams = new URLSearchParams(location.search);
        for (var _i = 0, _a = this.params; _i < _a.length; _i++) {
            var viewParam = _a[_i];
            if (viewParam.routeParameter.isQuery) {
                if (viewParam.update(queryParams.get(viewParam.name)))
                    hasChanged = true;
            }
        }
        return hasChanged;
    };
    /**
     * Gets a url for an object with view params specified.
     * @param basePath Base path without parameters
     * @param values Object of param names and values.
     */
    ViewParameterList.getPathForValues = function (basePath, params, values) {
        // TODO: This needs a rework.
        var viewParameterList = new ViewParameterList(params);
        for (var name_1 in values) {
            //@ts-ignore
            var viewParam = viewParameterList[name_1];
            if (viewParam) {
                var value = values[name_1];
                if (value === undefined)
                    value = null;
                if (typeof value === "number") {
                    value = value.toString();
                }
                viewParam.update(value);
            }
        }
        var state = { hasQuery: false };
        var paramPath = basePath;
        for (var _i = 0, _a = viewParameterList.params.filter(function (c) { return !c.routeParameter.isQuery; }); _i < _a.length; _i++) {
            var viewParam = _a[_i];
            paramPath += viewParam.getParamString(state);
        }
        // trim trailing slashes
        while (paramPath.endsWith("/")) {
            paramPath = paramPath.substring(0, paramPath.length - 1);
        }
        return paramPath + viewParameterList.getQueryString(state);
    };
    return ViewParameterList;
}());
export { ViewParameterList };
